import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { Card } from '@mui/material';
import OutsideClickHandler from 'react-outside-click-handler';

const OtherLayerSidebar = ({ otherLayerClosed, otherLayerShow, otherLayersChange, otherLayersList }) => {
    const layers = [
      { id: 'Zipcodes', label: 'Zipcode' },
      { id: 'Cities', label: 'City' },
      { id: 'Urban_area', label: 'Urban Areas' }
    ];

    return (
      <OutsideClickHandler onOutsideClick={otherLayerClosed}>
        <div className={otherLayerShow ? "Building-total top-400 top-auto" : "Building-total Building-total-hideval top-400"}>
          <div className="Building-title pl-15">Other Layers</div>
          <Card sx={{ boxShadow: 'none', padding: 0, bgcolor: 'white' }}>
            <div className="Building-total-each height-auto">
              {layers.map(layer => (
                <div 
                  key={layer.id}
                  className="layer-row"
                  onClick={() => otherLayersChange(layer.id)}
                >
                  <Checkbox
                    size="small"
                    checked={otherLayersList.includes(layer.id) ? true : false}
                    // onClick={(e) => e.stopPropagation()}
                  />
                  <span className="layer-label">{layer.label}</span>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </OutsideClickHandler>
    );
};

export default OtherLayerSidebar;